import { Configuration, LogLevel } from "@azure/msal-browser";
import { HIPAA_MSAL_CACHE_CONFIG } from "./hipaaSecurityConfig";

/**
 * Configuration object to be passed to MSAL instance on creation.
 */

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || "common"}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_AZURE_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: HIPAA_MSAL_CACHE_CONFIG.cacheLocation,
    storeAuthStateInCookie: HIPAA_MSAL_CACHE_CONFIG.storeAuthStateInCookie,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // Only log info in development mode
            if (import.meta.env.DEV) {
              console.info(message);
            }
            return;
          case LogLevel.Verbose:
            // Suppress verbose logs
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      // Set log level to Warning in production, Info in development
      logLevel: import.meta.env.PROD ? LogLevel.Warning : LogLevel.Info,
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  // Used for interactive login (basic Graph/profile scopes)
  scopes: ["User.Read"],
};

/**
 * API scopes for our OneView backend
 * Example value (set via env): api://<oneview-api-client-id>/user.read
 */
export const apiScopes: string[] = (
  import.meta.env.VITE_API_SCOPE || ""
)
  .split(" ")
  .map((s: string) => s.trim())
  .filter((s: string) => Boolean(s));

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API.
 * For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

